import React from 'react';

if (process.env.REACT_APP_ENABLE_WDYR?.toLowerCase() === 'true') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
